/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LossOfProductionMetricVariantCreateRequest
 */
export interface LossOfProductionMetricVariantCreateRequest {
    /**
     * Unique uuid key mapping to an i18n entry
     * @type {string}
     * @memberof LossOfProductionMetricVariantCreateRequest
     */
    name: string;
    /**
     * List of generator keys for this variant
     * @type {Array<string>}
     * @memberof LossOfProductionMetricVariantCreateRequest
     */
    generatorKeys: Array<string>;
    /**
     * List of generator status keys of this variant
     * @type {Array<string>}
     * @memberof LossOfProductionMetricVariantCreateRequest
     */
    generatorStatusKeys: Array<string>;
}

/**
 * Check if a given object implements the LossOfProductionMetricVariantCreateRequest interface.
 */
export function instanceOfLossOfProductionMetricVariantCreateRequest(value: object): value is LossOfProductionMetricVariantCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('generatorKeys' in value) || value['generatorKeys'] === undefined) return false;
    if (!('generatorStatusKeys' in value) || value['generatorStatusKeys'] === undefined) return false;
    return true;
}

export function LossOfProductionMetricVariantCreateRequestFromJSON(json: any): LossOfProductionMetricVariantCreateRequest {
    return LossOfProductionMetricVariantCreateRequestFromJSONTyped(json, false);
}

export function LossOfProductionMetricVariantCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossOfProductionMetricVariantCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'generatorKeys': json['generatorKeys'],
        'generatorStatusKeys': json['generatorStatusKeys'],
    };
}

export function LossOfProductionMetricVariantCreateRequestToJSON(json: any): LossOfProductionMetricVariantCreateRequest {
    return LossOfProductionMetricVariantCreateRequestToJSONTyped(json, false);
}

export function LossOfProductionMetricVariantCreateRequestToJSONTyped(value?: LossOfProductionMetricVariantCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'generatorKeys': value['generatorKeys'],
        'generatorStatusKeys': value['generatorStatusKeys'],
    };
}

